// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "customer." + chunkId + "." + {"libs_customer_customer-inventory-v1_src_index_ts":"a541ff5bef98fb12","libs_customer_customer-documents-v1_src_index_ts":"cc90d5d20de643c2","libs_customer_customer-approvals-v1_src_index_ts":"f4f725a9ce778cf2"}[chunkId] + ".js";
};